import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            // 주문정보
            orderDate:'',
            orderNumber:'',
            orderPeopleId:'',
            orderNickname:'',
            orderName:'',
            itemName:'',
            itemOption:'',

            // 배송정보
            zipCode:'',
            address:'',
            addressDetail:'',

            memo:'',
            detailMemo : '',//상세 메모
            shippingMemo : '',

            // 주문 취소 사유
            reason:'',
            // 사유 (선택)
            changeReason :'',

            // 송장번호 입력
            orderArr:[],
            selectExpress:'',
            invoice : '',

            // 상세에서 송장번호
            deliveryCompany : '',
            invoiceNumber:'',

            adminReason : '',
            cancelReason : '',

            //반품수령
            tradeZipcode:'',
            tradeAddress:'',
            tradeAddressDetail:'',
            tradeDeliveryMemo: '',
            //교환수령
            receiverZipcode:'',
            receiverAddress:'',
            receiverAddressDetail:'',
            receiverDeliveryMemo: '',
        }
    },
    validators: {
        cancelReason: function (value) {
            return Validator.value(value)
        },
        adminReason: function (value) {
            return Validator.value(value)
        },
        zipCode: function (value) {
            return Validator.value(value)
                .required('주소를 입력하세요.')
        },
        address: function (value) {
            return Validator.value(value)
        },
        addressDetail: function (value) {
            return Validator.value(value)
        },
        shippingMemo: function (value) {
            return Validator.value(value)
        },
        memo: function (value) {
            return Validator.value(value)
                .required('내용을 입력하세요.')
        },
        detailMemo: function (value) {
            return Validator.value(value)
        },
        reason: function (value) {
            return Validator.value(value)
                .required('내용을 입력하세요.')
        },
        changeReason :  function (value) {
            return Validator.value(value)
        },
        orderArr : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(util.isEmpty(value) || value.length < 1) {
                        return '주문건을 선택해주세요.'; // 보이진않음
                    }
                })
        },
        selectExpress : function (value) {
            return Validator.value(value)
                .required('배송사를 선택해주세요.')
        },
        invoice : function (value) {
            return Validator.value(value)
                .required('송장번호를 입력해주세요.')
        },
        invoiceNumber : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(!util.isEmpty(this.deliveryCompany) && util.isEmpty(value)) {
                        return '운송 정보를 다 입력해주세요.'
                    }
                })
        },
        deliveryCompany  : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(!util.isEmpty(this.invoiceNumber) && util.isEmpty(value)) {
                        return '운송 정보를 다 입력해주세요.'
                    }
                })
        },
        tradeZipcode: function (value) {
            return Validator.value(value)
                .required('주소를 입력하세요.')
        },
        tradeAddress: function (value) {
            return Validator.value(value)
        },
        tradeAddressDetail: function (value) {
            return Validator.value(value)
        },
        tradeDeliveryMemo: function (value) {
            return Validator.value(value)
        },
        receiverZipcode: function (value) {
            return Validator.value(value)
                .required('주소를 입력하세요.')
        },
        receiverAddress: function (value) {
            return Validator.value(value)
        },
        receiverAddressDetail: function (value) {
            return Validator.value(value)
        },
        receiverDeliveryMemo: function (value) {
            return Validator.value(value)
        },
    },
}
